import CompanyDepartmentUserRegistrationReducer from './CompanyDepartmentUserRegistrationReducer';

export default from './CompanyDepartmentUserRegistrationContainer';
export const CompanyDepartmentUserRegistrationReducers = {
  CompanyDepartmentUserRegistrationReducer,
};
